// src/constants/documentConstants.js

// Document categories
export const DOCUMENT_CATEGORIES = [
    { value: 'brief', label: 'Breif' },
    { value: 'proposal', label: 'Proposal' },
    { value: 'guideline', label: 'Guideline' },
    { value: 'requirements', label: 'Requirements' },
    { value: 'design', label: 'Designs' },
    { value: 'contract', label: 'Contracts' },
    { value: 'deliverable', label: 'Deliverables' },
    { value: 'communication', label: 'Communications' },
    { value: 'report', label: 'Reports' },
    { value: 'other', label: 'Other' }
  ];
  
  // Helper function to get icon by file type
  export const getFileIcon = (type) => {
    if (!type) return 'document';
    
    const lowerType = type.toLowerCase();
    
    if (lowerType.includes('image')) return 'image';
    if (lowerType.includes('pdf')) return 'pdf';
    if (lowerType.includes('excel') || lowerType.includes('spreadsheet') || lowerType.includes('csv')) return 'spreadsheet';
    if (lowerType.includes('powerpoint') || lowerType.includes('presentation')) return 'presentation';
    if (lowerType.includes('word') || lowerType.includes('document')) return 'document';
    if (lowerType.includes('code') || lowerType.includes('json') || lowerType.includes('html') || lowerType.includes('css') || lowerType.includes('javascript')) return 'code';
    
    return 'attachment';
  };